import Vue from 'vue';
import SitesMenu from './App.vue'

import Buefy from 'buefy';



Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

if(document.getElementById("sitesMenuApp")){
    new Vue({
        render: h => h(
            SitesMenu, {
                props:{
                    companiesEndpoint: document.getElementById("sitesMenuApp")
                        .getAttribute("companies-endpoint")
                }
            }
        )
    }).$mount('#sitesMenuApp')
}